import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
const sectionHeaderManagedAttrs = [
    "data-lp-component",
    "class",
];
function renderTitle(level, title) {
    if (level === 4) {
        return html `<h4 class="lp-section-header_title">${title}</h4>`;
    }
    if (level === 3) {
        return html `<h3 class="lp-section-header_title">${title}</h3>`;
    }
    return html `<h2 class="lp-section-header_title">${title}</h2>`;
}
export function LpSectionHeader({ title, description, level = 2, className, attributes, }) {
    return html `
        <div
            data-lp-component="SectionHeader"
            class="${cn("lp-section-header", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: sectionHeaderManagedAttrs })}
        >
            ${renderTitle(level, title)}
            ${description ? html `<p class="lp-section-header_description">${description}</p>` : ""}
        </div>
    `;
}
